export default __webpack_public_path__ + "static/media/G0000.22d36c49.png";